import React from 'react';
import PersonalInformationContext from './PersonalInformationContext';

function PersonalInformationWrapper(props) {
  const { form, children } = props;
  return <PersonalInformationContext.Provider value={{ form }}>{children}</PersonalInformationContext.Provider>;
}

export default PersonalInformationWrapper;
